//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFileName} from "@/util";

export default {
  name: "CartItem",
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    isRootItem: {
      type: Boolean,
      default: false
    },
    isMultipleItem: {
      type: Boolean,
      default: false
    },
    isSubItem: {
      type: Boolean,
      default: false
    },
    isPackage: {
      type: Boolean,
      default: false
    },
    isPackageWrap: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    parentQuantity: {
      type: Number,
      default: null
    },
    showSku: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      subGroupExpand: false,
      expandAnimateDelay: false
    }
  },
  computed: {
    title() {
      const itemTitle = this.isMultipleItem ? `Custom ${this.item.title}` : this.item.title;
      if(this.isPackageWrap) return this.$t('holidayGiftWrapTitle')
      return this.isPackage ? this.item.package?.title : itemTitle;
    },
    image() {
      if(this.isPackageWrap) return '/images/pages/holiday/so-giftwrap.jpg'
      return this.isPackage ? this.item.package?.image_url : this.item.image_url;
    },
    showDescription() {
      return !this.isMultipleItem && !this.isPackage && !this.isPackageWrap && this.item.description?.length && typeof this.item.description !== 'string';
    },
    showExpandControls() {
      const showPackage = this.item.package && Object.keys(this.item.package).length && this.item.show_package;
      return (this.isRootItem && this.isMultipleItem) || (this.isRootItem && showPackage);
    },
    showQty() {
      return !this.isPackage && !this.isPackageWrap && this.readOnly || this.isSubItem;
    },
    hasValentinesDaySale() {
      return this.item.sale && this.item.sale.code === 'VDAY'
    },
  },
  methods: {
    getFileName,
    validateCount(item, blur) {
      if (this.loading && blur) {
        return;
      }
      this.$nextTick(() => {
        if (typeof item.quantity !== 'number') {
          item.quantity = item.quantity.replace(/\D/g, '');
        }
        if ((isNaN(Number(item.quantity)) || Number(item.quantity) < 1) && item.quantity !== '' && !blur) {
          item.quantity = 1
        } else if (item.quantity !== '' && !blur) {
          item.quantity = Number(item.quantity);
        } else if (blur) {
          item.quantity = Number(item.quantity) ? Number(item.quantity) : 1;
        }
        this.$forceUpdate();
        if (item.quantity) {
          this.$emit('debItemCount', item);
        }
      })
    },
    itemCount(item, plus) {
      item.quantity = Number(item.quantity);
      if (this.loading || !plus && item.quantity === 1) {
        return;
      }
      item.quantity = plus ? item.quantity + 1 : item.quantity - 1;
      this.$forceUpdate();
      this.$emit('debItemCount', item);
    },
    removeItem() {
      if (this.isRootItem) {
        this.$emit('remove', this.item);
      }
      if (this.isPackage) {
        this.$emit('removeIncludedPackage', this.item);
      }
      if (this.isPackageWrap) {
        this.$emit('removeIncludedPackageWrap', this.item);
      }
    },
    toggleSubGroupExpand(e) {
      if (this.expandAnimateDelay) {
        return;
      }
      this.subGroupExpand = !this.subGroupExpand;
      const subGroupElement = e.target.closest('.product-cart-item-wrap').querySelector(`.sub-group-${this.item.id}`);
      if (subGroupElement) {
        if (!this.subGroupExpand) {
          subGroupElement.style.height = `${subGroupElement.offsetHeight}px`;
        }
        setTimeout(() => {
          subGroupElement.style.height = this.subGroupExpand ? `${subGroupElement.scrollHeight}px` : 0;
        })
        this.expandAnimateDelay = true;
        const expandAnimationDuration = 500;
        setTimeout(() => {
          if (this.subGroupExpand) {
            subGroupElement.style.height = 'auto';
          }
          this.expandAnimateDelay = false;
        }, expandAnimationDuration)
      }
    }
  }
}
